import WeddingEventDetails from './WeddingEventDetails';

export default WeddingEventDetails;
